module.exports = __webpack_public_path__ + "static/img/zhushihua1.40333282.png";